export function showSnackbar(payload){
    return { type: "UI_SHOW_SNACK_BAR", payload:payload  }
}

export function hideSnackbar(payload){
    return { type: "UI_HIDE_SNACK_BAR", payload:payload  }
}